import {Injectable} from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {confirmation} from '../mocks/confirm-response-for-request';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor() { }

  async success(message: string): Promise<any> {
    return Swal.fire(confirmation(`${message}`,
    'top-end', 'success', true, 10000));
  }

  async danger(message: string, name?: string ): Promise<any> {
    return Swal.fire(confirmation(`${message}`,
                  'center', 'error', true, 7000));
  }

  async warning(message: string, name?: string): Promise<any> {
    return Swal.fire(confirmation(`${message} : ${name}`,
    'center', 'warning', true, 7000));
  }

  async showNotification(message: string): Promise<any> {
    return Swal.fire(confirmation(`${message}`,
    'center', 'warning', true, 10000));
  }


}
